module.exports = __webpack_public_path__ + "img/comment-image.37d3feeb.svg";